module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row user-stats"
  }, [_c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-send",
      "stats": _vm.getCalculations.started
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Rozpoczęte kalkulacje")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-list",
      "stats": _vm.getCalculations.completed
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Zakończone kalkulacje")])])], 2)], 1), _vm._v(" "), (_vm.showStatsFor('cpl')) ? _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-doc",
      "stats": _vm.getCalculations.phone_confirmed
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Potwierdzone kalkulacje")])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showStatsFor('cps')) ? _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-doc",
      "stats": _vm.getCalculations.sold_policies
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Sprzedane polisy")])])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.getPayment.saldo,
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Twoje środki")])])], 2)], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getPending
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe3af34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statsGrid.vue
// module id = 379
// module chunks = 0